import React from 'react';
import PropTypes from 'prop-types';
import { LinksForUserProfile } from '../UserDetails.styles';
import LeftArrow from '../../Visuals/Icons/LeftArrow.icon';
const UserCoursesSideMenu = ({
  user,
  setSelectedSection,
  selectedCourseId,
  setSelectedCourseId,
}) => (
  <LinksForUserProfile>
    <p onClick={() => setSelectedSection('details')}>
      <LeftArrow />
      Back
    </p>
    {user?.courses?.length < 1 ? (
      <span>User has no courses</span>
    ) : (
      // <ul className="courses-grid">
      <div className="links">
        {user?.courses?.map((c) => (
          <a
            key={c._id}
            className={`courseHover${selectedCourseId === c?._id ? ' selected' : ''}`}
            href="#"
            style={{ color: c?.complete ? '#3db36b' : '#e53935' }}
            onClick={() => setSelectedCourseId(c?._id)}
          >
            {c?.courseName}
          </a>
        ))}
      </div>
      // </ul>
    )}
  </LinksForUserProfile>
);
UserCoursesSideMenu.propTypes = {
  user: PropTypes.object,
  setSelectedSection: PropTypes.func,
  selectedCourseId: PropTypes.string,
  setSelectedCourseId: PropTypes.func,
};

export default UserCoursesSideMenu;
